import { Typography, emptyFragment } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../Translations';
import { ExperienceDictionaryEntryResponse } from '../../../../../../ExperiencesDictionary/Types';

interface Props {
  experience: ExperienceDictionaryEntryResponse;
}

function TimeCommitment({ experience }: Props) {
  const { offeringType, duration, hoursPerWeek, totalHours } = experience.payload;

  switch (offeringType) {
    case 'aep':
    case 'epc':
    case 'msuite':
      return (
        <div className="flex flex-col gap-y-1">
          {duration
            .map((duration) => (
              <Typography variant="caption" as="p">
                <T kind="{{count}} week" count={duration} />
              </Typography>
            ))
            .getOrElse(emptyFragment)}
          {hoursPerWeek
            .map((count) => (
              <Typography variant="caption" as="p">
                <T kind="{{count}} hour per week" count={count} />
              </Typography>
            ))
            .getOrElse(emptyFragment)}
          {totalHours
            .map((totalHours) => (
              <Typography variant="caption" as="p">
                <T kind="{{count}} total hour" count={totalHours} />
              </Typography>
            ))
            .getOrElse(emptyFragment)}
        </div>
      );
    case 'coaching':
    case 'group-coaching':
    case 'program-sequence':
      //TODO
      // return <ExperienceProductDetails experienceResource={experienceResource} />;
      return emptyFragment();
  }
}

export default observer(TimeCommitment);
